import { AddressPopup } from '../map.service';
import { RadarDtg } from 'src/app/radar/radar.service';

import moment from 'moment';
import { pigeonColor } from 'src/app/pigeons/constants/constants';

export const getEopValue = (
  parameter: string,
  addressPopup: AddressPopup,
  dtgs: RadarDtg[],
  dtgIndex: number,
  testMode: boolean
) => {
  if (!addressPopup.eopData) {
    return null;
  }
  const dtg =
    moment.unix(dtgs[dtgIndex].slider).utc().format('YYYY-MM-DDTHH') +
    ':00:00Z';
  for (const eopData of addressPopup.eopData.eop2items) {
    if (eopData['dtg'] === dtg || testMode) {
      if (eopData.hasOwnProperty(parameter)) {
        return eopData[parameter];
      }
      return null;
    }
  }
};
export const MAX_MERCATOR_LAT = 85.05112878;

export const pigeonRoutePartColor = (
  index: number,
  pigeonRouteDetails: any,
  parameter: string,
  pigeonStationTime: any,
  pigeonsServiceStartHour: number,
  pigeonsServiceParameterInfo: any,
  pigeonMos: any,
  dtgs: any,
  dtgIndex: any,
  pigeonsServiceEndHour: number,
  pigeonServiceDay: any,
  pigeonServiceMosData: any,
  param?: string
): string => {
  const currentParameter = param
    ? param
    : pigeonsServiceParameterInfo[parameter].name;
  const stationId = pigeonRouteDetails.stations[Math.max(0, index)].stationId;
  // selected hour
  // const hour = moment.unix(this.dtgs()[this.dtgIndex()].slider).hour();
  // hour for station
  const stationHourIndex =
    pigeonStationTime[stationId] - pigeonsServiceStartHour;
  const color = pigeonColor(
    currentParameter,
    stationId,
    pigeonMos,
    dtgs,
    dtgIndex,
    stationHourIndex,
    pigeonsServiceEndHour,
    pigeonsServiceStartHour,
    pigeonServiceDay,
    pigeonServiceMosData
  );
  return color;
};

export const pad = (num: number, size: number): string => {
  let s = num + '';
  while (s.length < size) {
    s = '0' + s;
  }
  return s;
};
